/* eslint-disable react/display-name */
/* eslint-disable camelcase */
/* eslint-disable comma-dangle */

import React from 'react';
import dynamic from 'next/dynamic';
import Highlight from 'react-scale/components/elements/highlight';
import ExampleLoading from '../ExampleLoading';

const TaskResponseDocumentMLTranscription = dynamic(
  () => import('../tasks/TaskResponseDocumentMLTranscription'),
  {
    loading: () => <ExampleLoading />,
    ssr: false
  }
);

export const instruction = 'Transcribe the menu.';

export const responseCode = `{
  "response": {
    "annotations": {
      "item_name": {
        "type": "text",
        "response": ["Cheeseburger"]
      },
      "item_price": {
        "type": "number",
        "response": [7.95]
      }
      ...
    }
  },
  "task_id": "5795c68afce306120434be64",
  "task": { ... }
}`;

export const code = `client.createTextCollectionTask({
  callback_url: 'http://www.example.com/callback',
  instruction: '${instruction}',
  params: {
    attachments: [
      {
        type: 'image',
        content: 'restaurant-menu.jpg'
      }
    ],
    fields: [
      {
        field_id: 'item_name',
        title: 'Item name',
        required: true,
        type: 'text'
      },
      {
        field_id: 'item_price',
        title: 'Price',
        required: true,
        type: 'number',
        digits: 2,
      }
    ]
  }
});`;

export const response = (
  <div className="data-collection">
    <Highlight className="javascript" key="highlight-json">
      {responseCode}
    </Highlight>
  </div>
);

export const example = () => <TaskResponseDocumentMLTranscription howItWorks />;

export const result = <TaskResponseDocumentMLTranscription animate howItWorks />;
